import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'intro',
    (theme, [hasTitle]) => [
	  `
			:lang(ar){
				transform: scaleX(-1);
				direction: rtl;
			}
			position: relative;
			bottom: 0;
			width: 100%;
			padding: ${hasTitle ? '20px' : '30px 40px'};
			line-height: 1.5;
			overflow: hidden;
			box-sizing: border-box;
		`,
      hasTitle &&
        `
			font-size: 14px;
			color: ${theme.color.text.B4};
		`,
      !hasTitle &&
        `
			font-size: 14px;
		`
    ]
  ]
]);
